import { render, staticRenderFns } from "./HorizontalMenu.vue?vue&type=template&id=2b05d8b5&scoped=true&"
import script from "./HorizontalMenu.vue?vue&type=script&lang=ts&"
export * from "./HorizontalMenu.vue?vue&type=script&lang=ts&"
import style0 from "./HorizontalMenu.vue?vue&type=style&index=0&id=2b05d8b5&prod&lang=scss&scoped=true&"
import style1 from "./HorizontalMenu.vue?vue&type=style&index=1&id=2b05d8b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b05d8b5",
  null
  
)

export default component.exports